import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setLoginVisible, setSignupVisible } from '../../features/dialogControl/dialogControlSlice';
import { graphqlRequest } from '../../services/graphql-service';
import { LOGIN_USER } from '../../config/queries';
import { 
    IconButton,
    Box,
    Button
} from "@mui/material";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import './login.css';
import { CustomTextField } from '../form-elements/form-elements'; 
import { useTheme } from '@mui/material/styles';
import { toast } from 'react-toastify';
// import {
//     FacebookLoginButton,
//     GoogleLoginButton,
// } from "react-social-login-buttons";


const initialLoginData = {
    email: '',
    password: '',
}



const Login = () => {
    const [loginData, setLoginData] = useState(initialLoginData);
    const [error, setError] = useState('');
    const theme = useTheme();
    const dispatch = useDispatch();

    const handleCancelClick = (event) => {
        event.stopPropagation();
        if (event.target.id !== 'dialog-container') dispatch(setLoginVisible(false));
    }

    const handleFormChange = (field, value) => {
        // const updatedData = { ...loginData, [field]: value };
        // setLoginData(updatedData); 
        setLoginData((prev) => ({
            ...prev,
            [field]: value || '', 
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        console.log("Form submitted:", loginData);
        try {
            console.log("Logging in with:", loginData);
            const variables = {
              email: loginData.email,
              password: loginData.password
            };
      
            const response = await graphqlRequest(LOGIN_USER, variables);
            console.log("Login response:", response);
      
            if (!response.login.success) {
              setError(response.login.message);
              toast.error(response.login.message);
              return;
            }
      
            toast.success("Login successful!");
            dispatch(setLoginVisible(false));
      
            // Store user info in localStorage or Redux (optional)
            localStorage.setItem('mb-user', JSON.stringify(response.login.user));
      
            setLoginData(initialLoginData);
            window.location.reload();
          } catch (error) {
            console.error("Login error:", error);
            setError("An error occurred. Please try again.");
            toast.error("An error occurred. Please try again.");
          }
        
        // dispatch(setLoginVisible(false));
    };

    const handleLogin = (e) => {
        e.preventDefault();
        dispatch(setLoginVisible(true));
        dispatch(setSignupVisible(false));
    };

    const handleCreateAccount = (e) => {
        e.preventDefault();
        dispatch(setLoginVisible(false));
        dispatch(setSignupVisible(true));
    };


    return (
        <div className='screen'>
            <div id='dialog-container' className='dialog-container'>
                <div className='dialog-header'>Sign in to your MusicBlox account</div>
                <Box 
                    component="form"
                    onSubmit={handleSubmit}
                    autoComplete='off'
                    sx={{ 
                        display:'flex', 
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        width: '427px',
                    }}
                >
                    <div className='dialog-sub-text'>USE EMAIL TO SIGN IN</div>
                    <Box>
                        <CustomTextField
                            sx={{
                                width: '427px'
                            }}
                            size="small"
                            label="EMAIL"
                            name="email"
                            value={loginData.email}
                            onChange={(e) => handleFormChange("email", e.target.value)}
                            variant="outlined"
                            fullWidth
                            autoComplete="off"
                        />
                    </Box>

                    <Box>
                        <CustomTextField
                            sx={{
                                width: '427px'
                            }}
                            size="small"
                            type="password"
                            label="PASSWORD"
                            name="password"
                            value={loginData.password}
                            onChange={(e) => handleFormChange("password", e.target.value)}
                            variant="outlined"
                            fullWidth
                            autoComplete="off"
                        />
                    </Box>
                    
                    {error && <Box sx={{ color: 'red', fontSize: '14px', marginBottom: '10px' }}>{error}</Box>}
                    
                    <Button 
                        sx={{
                            width:'86px',
                            height: '32px',
                            borderRadius: '4px',
                            marginBottom: '20px'
                        }}
                        type="submit" 
                        variant="contained" 
                        color="primary" 
                        fullWidth
                    >
                        Submit
                    </Button>

                    {/* <div className='dialog-sub-text'>OR SIGN IN WITH</div>
                    
                    <Box
                        sx={{
                            marginBottom: '10px',
                            display:'flex'
                        }}
                    >
                        <GoogleLoginButton 
                            onClick={() => console.log('google login')} 
                            style={{
                                display:'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '12px',
                                borderRadius: '20px',
                                height: '40px',
                                width: '200px',
                                margin: '0px'
                            }}
                        />
                        <FacebookLoginButton 
                            onClick={() => console.log('google login')} 
                            style={{
                                display:'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '12px',
                                borderRadius: '20px',
                                height: '40px',
                                width: '200px',
                                margin: '0 0 0 20px'
                            }}
                        />
                    </Box> */}
                    
                    
                
                </Box>

                <Box>
                    <Box 
                        sx={{marginTop: '10px'}}
                    >
                        <p
                            className='dialog-help-note'
                        >
                            Dont have an account? 
                            <NavLink 
                                className='dialog-help-link' 
                                to='/'
                                onClick={(event) => handleCreateAccount(event)} 
                            >
                                Join the MusicBlox Beta Waitlist
                            </NavLink>
                        </p>
                    </Box>
                    <Box>
                        <p
                            className='dialog-help-note'
                        >
                            Having trouble? 
                            <NavLink 
                                className='dialog-help-link' 
                                to='/'
                                onClick={(event) => handleLogin(event)} 
                            >
                                Reach out 
                            </NavLink>
                        </p>
                    </Box>
                </Box>
                
                <div className='close-button'>
                    <IconButton
                        onClick={(event) => handleCancelClick(event)}
                    >
                        <CancelOutlinedIcon 
                            sx= {{
                                color:theme.palette.color
                            }}
                        />
                    </IconButton>
                </div>
            </div>
        </div>
    );
}

export default Login;